import * as React from 'react';
import {translate, InjectedTranslateProps} from 'react-i18next';
import {reportClick} from '../../utils/bi';
import LinkMore from '../LinkMore';
import Text from '../Text';
import * as s from './IntroText.scss';

export interface IntroTextConfig {
  key: string;
}

export interface IntroTextProps extends InjectedTranslateProps, IntroTextConfig {
}

const IntroText: React.SFC<IntroTextProps> = ({t}) => {
  return (
    <div
        className={`page-fold ${s.introText}`}
        data-hook="intro-text-fold"
        data-foldname="intro-text"
        data-foldnum="2"
    >
      <Text parent="h2" className={s.title} i18nKey="intro.title" />
      <Text parent="p" className={s.text} i18nKey="intro.text" />
      <div className={s.footer}>
        <LinkMore
          className={s.linkMore}
          data-hook="intro-text-get-started"
          data-foldname="intro-text"
          onClick={reportClick}
        >
          {t('button.getStarted')}
        </LinkMore>
      </div>
    </div>
  );
};

export default translate()(IntroText);
